module.exports = __webpack_public_path__ + "static/media/hotel-5.577d8e81.jpg";